import type { ApiEmbedSearchWidgetId } from '#/api/types/ApiTypedId';
import type { I18nLocale } from '#/i18n/types/I18nLocale';
import { embedSearchWidgetSearchVolopsRoute } from '#/modules/embedSearchWidget/routing/embedSearchWidget.routes';
import type { RadiusParam } from '#/modules/search/helpers/radius';
import { searchVolopsRouteReference } from '#/modules/search/routing/search.routes';
import type { SearchVolopFiltersByName } from '#/modules/search/types/FiltersByName/SearchVolopFiltersByName';
import type { SearchSortType } from '#/modules/search/types/SearchSortType';
import { searchVolopsRoutePathByLocale } from '#/modules/search/volops/routing/seachVolops.route-paths';

import { searchGetQueryParamsFromFiltersByName } from '../../routing/helpers/searchGetQueryParamsFromFiltersByName';

type Args = {
  locale: I18nLocale;
  q?: string;
  radius?: RadiusParam;
  filtersByName?: Omit<SearchVolopFiltersByName, 'type'>;
  sort?: SearchSortType;
  pageIndex?: number;
  embedSearchWidgetId: ApiEmbedSearchWidgetId | null;
};

export function searchGetVolopsRoutePath({
  locale,
  filtersByName,
  q,
  radius,
  sort,
  pageIndex,
  embedSearchWidgetId,
}: Args) {
  const queryParams = searchGetQueryParamsFromFiltersByName(filtersByName);
  if (q) queryParams.q = q;
  if (radius) queryParams.radius = radius;
  if (sort && sort !== 'relevance') queryParams.sort = sort;
  if (pageIndex) queryParams.page = pageIndex + 1;

  if (embedSearchWidgetId) {
    return embedSearchWidgetSearchVolopsRoute.with({
      ...queryParams,
      lang: locale,
      embedSearchWidgetId,
    });
  }

  return searchVolopsRouteReference
    .with(queryParams)
    .replace('/-lang/-segment', searchVolopsRoutePathByLocale[locale]);
}
